import React from "react";

const ControlPanel = (props) => {
  const windowwidth = window.innerWidth;
  
  const {
    file,
    pageNumber,
    numPages,
    setPageNumber,
    scale,
    setScale,
    nextPageNumber,
    setNextPageNumber,
  } = props;

  const isFirstPage = pageNumber <= 1;
  const isLastPage = pageNumber + 2 > numPages;

  

  const firstPageClass = isFirstPage ? "disabled" : "clickable";
  const lastPageClass = isLastPage ? "disabled" : "clickable";

  const goToFirstPage = () => {
    if (!isFirstPage) {
      setPageNumber(1);
      setNextPageNumber(2);
    }
  };
  const goToPreviousPage = () => {
    if (!isFirstPage) {
      if (windowwidth > 767) {
        setPageNumber(pageNumber - 2);
        setNextPageNumber(nextPageNumber - 2);
      } else {
        setPageNumber(pageNumber - 1);
        setNextPageNumber(nextPageNumber - 1);
      }
    }
  };


  const goToNextPage = () => {
    if (!isLastPage) {
      if (windowwidth > 767) {
        setPageNumber(pageNumber + 2);
        setNextPageNumber(nextPageNumber + 2);
      } else {
        setPageNumber(pageNumber + 1);
        setNextPageNumber(nextPageNumber + 1);
      }

      // setPageNumber(pageNumber + 2);
      // setNextPageNumber(nextPageNumber + 2);
    }
  };
  const goToLastPage = () => {
    if (!isLastPage) {
      setPageNumber(numPages);
      // setNextPageNumber(numPages + 1);
    }
  };

  const onPageChange = (e) => {
    const { value } = e.target;
    setPageNumber(Number(value));
  };

  const isMinZoom = scale < 0.6;
  const isMaxZoom = scale >= 2.0;

  const zoomOutClass = isMinZoom ? "disabled" : "clickable";
  const zoomInClass = isMaxZoom ? "disabled" : "clickable";

  const zoomOut = () => {
    if (!isMinZoom) setScale(scale - 0.1);
  };

  const zoomIn = () => {
    if (!isMaxZoom) setScale(scale + 0.1);
  };

  return (
    <div className="control-panel m-3 py-3 d-flex flex-column">
      <div className="d-flex justify-content-between align-items-baseline pdf_page_search">
        {/* <i
          className={`fas fa-fast-backward mx-3 ${firstPageClass}`}
          onClick={goToFirstPage}
        /> */}
        <i
          className={`fas fa-backward mx-3 ${firstPageClass}`}
          onClick={goToPreviousPage}
        />
        <span className="d-flex align-items-center wht_spc_nowrp">
          Page{" "}
          {/* <input
            name="pageNumber"
            type="number"
            min={1}
            max={numPages || 1}
            className="p-0 pl-1 mx-2 pdf_bv_input"
            value={pageNumber}
            onChange={onPageChange}
          />{" "} */}
          {pageNumber} of {numPages}
        </span>
        <i
          className={`fas fa-forward mx-3 ${lastPageClass}`}
          onClick={goToNextPage}
        />
        {/* <i
          className={`fas fa-fast-forward mx-3 ${lastPageClass}`}
          onClick={goToLastPage}
        /> */}
      </div>
      <div className="d-flex justify-content-between align-items-baseline d-md-none mt-3">
        <i
          className={`fas fa-search-minus mx-3 ${zoomOutClass}`}
          onClick={zoomOut}
        />
        <span>{(scale * 100).toFixed()}%</span>
        <i
          className={`fas fa-search-plus mx-3 ${zoomInClass}`}
          onClick={zoomIn}
        />
      </div> 
    </div>
  );
};

export default ControlPanel;
